import React from 'react';

import logo from '../images/icon-short.png';

interface Props {
  width?: number;
  height?: number;
}

const Icon: React.FC<Props> = ({ width, height }) => (
  <img
    alt="foongit logo"
    height={height >= 0 ? `${height}px` : ''}
    width={width >= 0 ? `${width}px` : ''}
    src={logo}
  />
);

export default Icon;
